import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ShippingPlanService, ShippingPlanResponse, Plan } from '@vestiaire/api-sdk-angular';

@Injectable({
  providedIn: 'root'
})
export class ShippingService {
  constructor(private shippingPlanService: ShippingPlanService) {}

  getDirectShippingEligibility(countryCode: string): Observable<boolean> {
    return this.shippingPlanService.getShippingEligibility(countryCode).pipe(
      map((res: ShippingPlanResponse) => res.data.shippingPlan.filter(e => e['directShipping'])),
      map((plans: Plan[]) => (plans.length > 0 ? plans[0]['directShipping'] : false))
    );
  }
}
